import constantes from "../../constantes";

const cotizacion = {
    id: null,
    bdt4: false,
    bdt1: false,
    ndt13: 0,
    ndt10: 0,
    ndt3: 0,
};
const vacio = {
    1: {
        modelo: {
            id: null,
            elements: [],
        },
        provincia: {
            id: null,
        }
    },
    2: {
        terminos: false,
        version: {id: null,ndt10:0},
        potencia: {
            motor: {id: null},
            traccion: {id: null},
            transmision: {id: null},
        },
        paquete: {id: null},
        color: {id: null},
        accesorios: {
            individuales: [],
            kit: [],
            cupones: [],
        }
    },
    3: {
        resumen: [],
        total: 0,
    }
};
export default {
    state: {
        actual: null,
        subactual: constantes.Constantes.pasos[1].pasos[0].titulo,
        data: vacio,
        precio: 0,
        campana: 0,
        cotizacion: cotizacion,
        pago: {
            tipo: null,
            pasarela: null,
            valor: null,
        },
    },
    mutations: {
        setCampana(state, numero) {
            numero = parseInt(numero);
            const keys = Object.keys(constantes.Constantes.enumeraciones.campana);
            state.campana = 0;
            keys.forEach(i => {
                if (constantes.Constantes.enumeraciones.campana[i] === numero)
                    state.campana = numero
            });
        },
        setActual(state, paso) {
            state.actual = paso;
        },
        setSubActual(state, paso) {
            if (state.actual === 2)
                state.subactual = constantes.Constantes.pasos[1].pasos[paso].titulo;
            let elemento = document.getElementById("sub-menu");
            if (elemento)
                elemento.scrollIntoView();
        },
        setPaso(state, dto) {
            state.data[dto.p] = dto.data;
        },
        setPrecio(state, precio) {
            state.precio = precio;
        },
        limpiar(state) {
            state.data = {
                "1": {
                    "modelo": {
                        "id": null,
                        "elements": []
                    },
                    "provincia": {
                        "id": null
                    }
                },
                "2": {
                    "terminos": false,
                    "version": {
                        "id": null,
                        "ndt10": 0
                    },
                    "potencia": {
                        "motor": {
                            "id": null
                        },
                        "traccion": {
                            "id": null
                        },
                        "transmision": {
                            "id": null
                        }
                    },
                    "paquete": {
                        "id": null
                    },
                    "color": {
                        "id": null
                    },
                    "accesorios": {
                        "individuales": [],
                        "kit": [],
                        "cupones": []
                    }
                },
                "3": {
                    "resumen": [],
                    "total": 0
                }
            };
            state.precio = 0;
            state.subactual = 0;
            state.actual = null;
            //state.actual=1;
        },
        limpiarSub(state) {
            state.data[2].accesorios.kit=[];
            state.data[2].accesorios.individuales=[];
            state.data[2].accesorios.cupones=[];
            state.data[2].color.id=null;
        },
        eliminarAc(state, obj) {
            const elemento = obj.item;
            const objeto = obj.obj;
            let arrays = state.data[objeto.paso]
            if(objeto.subArray){
                arrays = arrays[objeto.array][objeto.subArray];
            }else{
                arrays = arrays[objeto.array];
            }
            const a = arrays.findIndex(item => item[objeto.id] === elemento[objeto.id]);
            if (a >= 0)
                if(objeto.subArray){
                    state.data[objeto.paso][objeto.array][objeto.subArray].splice(a, 1);
                }else{
                    state.data[objeto.paso][objeto.array].splice(a, 1);
                }
        },
        setCotizacion(state, nueva) {
            state.cotizacion = nueva;
            state.cotizacion.valor = null;
        },
        clearCotizacion(state) {
            state.cotizacion = cotizacion;
        },
        setPago(state, obj) {
            state.pago.tipo = obj.tipo;
            state.pago.pasarela = obj.pasarela;
            state.pago.valor = obj.valor;
        },
        clearPago(state) {
            state.pago.tipo = null;
            state.pago.pasarela = null;
            state.pago.valor = null;
        },
    },
    getters: {
        getCampana: state => {
            return state.campana;
        },
        getNumData: state => {
            return Object.keys(state.data).length;
        },
        getActual: state => {
            return (state.actual);
        },
        getPrecio: state => {
            return (state.precio);
        },
        getSubActual: state => {
            return (state.subactual);
        },
        getPasos: state => {
            return (state.data);
        },
        getPasoActual: state => {
            function buscar(numero) {
                for (let i = 0; i < constantes.Constantes.pasos.length; i++) {
                    if (constantes.Constantes.pasos[i].numero === numero) {
                        return constantes.Constantes.pasos[i];
                    }
                }
            }

            return (buscar(state.actual));
        },
        getCotizacion: state => {
            return state.cotizacion;
        },
        getPago: state => {
            return state.pago;
        },
    }
}
